import en_gb from './en_gb.js';
import pl_pl from './pl_pl.js';
import de_de from './de_de.js';

const langFile = {
  en_gb,
  pl_pl,
  de_de,
};

export default langFile;
